import React from 'react';

import './QuestionPrompt.sass';

export default function QuestionPrompt(props: any) {
	return (
		<div className="QuestionPrompt" onClick={props.onClick}>
			<div className={["Answer", props.answer ? "filled" : ""].join(" ")}>
				<div>{props.answer}</div>
			</div>
		</div>
	);
}
